<script lang="ts" setup>
import { UiBtn } from '@shared/ui';
import type { AuthBtnProps } from './types';
import { useAuthStore } from '@/app/modules/auth/stores/AuthStore';

withDefaults(defineProps<AuthBtnProps>(), {
  label: 'Войти',
  size: 'md',
  color: 'primary',
});

const authStore = useAuthStore();

const loginAction = async () => {
  await authStore.setAuthLinks().then(() => {
    navigateTo(authStore.authLinks.login_url, { external: true });
  });
};
</script>

<template>
  <UiBtn
    :label="label"
    :color="color"
    @click="loginAction"
  />
</template>
